var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Button from '../button';
import Icon from '../icon';
import Transition from '../transition';
import { Styled } from './style';
var NotificationPortal = /** @class */ (function (_super) {
    __extends(NotificationPortal, _super);
    function NotificationPortal(props) {
        var _this = _super.call(this, props) || this;
        _this.el = document.createElement('div');
        return _this;
    }
    NotificationPortal.prototype.componentDidMount = function () {
        document.body.appendChild(this.el);
    };
    NotificationPortal.prototype.componentWillUnmount = function () {
        document.body.removeChild(this.el);
    };
    NotificationPortal.prototype.render = function () {
        return ReactDOM.createPortal(this.props.children, document.body);
    };
    return NotificationPortal;
}(React.PureComponent));
var NotificationExpandable = /** @class */ (function (_super) {
    __extends(NotificationExpandable, _super);
    function NotificationExpandable(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClose = function () {
            if (_this.props.onClose) {
                _this.props.onClose();
            }
        };
        _this.toggleExpandable = function () {
            _this.setState(function (prevState) { return ({
                isExpanded: !prevState.isExpanded,
            }); });
        };
        _this.state = {
            isExpanded: _this.props.isExpanded,
        };
        return _this;
    }
    NotificationExpandable.prototype.render = function () {
        var _a = this.props, title = _a.title, content = _a.content, isVisible = _a.isVisible;
        return (React.createElement(NotificationPortal, null,
            React.createElement(Transition.Group, { animation: 'fade up', duration: 200 }, this.props.isVisible &&
                React.createElement(Styled, { className: (this.state.isExpanded ? 'expandable-open' : 'expandable-closed') + " " + (isVisible ? 'visible' : '') },
                    React.createElement("div", { className: "notification-expandable-header" },
                        title,
                        React.createElement(Button, { transparent: true, className: "btn-expandable", onClick: this.toggleExpandable },
                            React.createElement(Icon, { name: "arrow-down" })),
                        React.createElement(Button, { transparent: true, onClick: this.handleClose },
                            React.createElement(Icon, { name: "close" }))),
                    React.createElement("div", { className: "notification-expandable-content" }, content)))));
    };
    return NotificationExpandable;
}(React.Component));
export default NotificationExpandable;
//# sourceMappingURL=index.js.map